import type { CategoryProduct } from '../pages/CategoryPage'

/**
 * Mock category data for the sandbox preview.
 *
 * In WebsiteForge these category pages are generated dynamically from the
 * ecommerce module, so this data is for demo/visual purposes only. The
 * `CategoryPage` template is the real deliverable.
 */

const GEN3_EFOOT_URL = '/m5/EPRO%2029039--gen3-e-foot-gear.html'

const DAEDO_PSS_PRODUCTS: CategoryProduct[] = [
  {
    name: 'Gen3 PSS-Gloves USAT',
    price: '$69.00',
    image:
      'https://cdn.magicpatterns.com/uploads/niYhHZHhKrMG2frXtC3Vmj/Gen3_PSS-Gloves_USAT.png',
    hasConfigurator: true,
    href: '/m5/EPRO%2029943--Official-Daedo-Gen3-Gloves.html',
  },
  {
    name: 'Gen3 E-Foot Gear',
    price: '$110.84',
    image:
      'https://cdn.magicpatterns.com/uploads/cViGkDXcDmPVipYt9uyQmt/Gen3_E-Foot_Gear.jpg',
    hasConfigurator: true,
    href: GEN3_EFOOT_URL,
  },
  {
    name: 'Gen2 Transmitter Charger',
    price: '$55.00',
    image:
      'https://cdn.magicpatterns.com/uploads/qEV6XsHhowYMSa1F9qrPwc/Gen2_Transmitter_Charger.jpg',
  },
  {
    name: 'Gen2 W.T. Software',
    price: '$99.00',
    image:
      'https://cdn.magicpatterns.com/uploads/orVwRQoYnnfYKgyRtLXkKq/Gen2_W.T._Software.jpg',
  },
  {
    name: 'Gen2 Judge Box (Refurbished)',
    price: '$580.00',
    image:
      'https://cdn.magicpatterns.com/uploads/bS347spy52LoYXHH7zr4qL/Gen2_Judge_Box_(Refurbished)_Same_Warranty.jpg',
  },
  {
    name: 'Gen2 Receiver',
    price: '$390.00',
    image:
      'https://cdn.magicpatterns.com/uploads/w3Q65FCerZEu2ek6y4Xdyo/Gen2_Receiver.jpg',
  },
  {
    name: 'Gen2 E-HeadGear',
    price: '$399.00',
    image:
      'https://cdn.magicpatterns.com/uploads/oEDj2ZvCJJBgsVECUR8bR3/Gen2_E-HeadGear.jpg',
    hasConfigurator: true,
  },
  {
    name: 'Gen2 Head Transmitter',
    price: '$390.00',
    image:
      'https://cdn.magicpatterns.com/uploads/keKg2f8ApxK9KnFdbJLkPa/Gen2_Head_Transmitter.jpg',
  },
]

const DAEDO_PRODUCTS: CategoryProduct[] = [
  {
    name: 'Gen3-PSS-Gloves USAT',
    price: '$69.00',
    image:
      'https://cdn.magicpatterns.com/uploads/fFmeJSZ4XSZWsghGfFQJi4/Gen3_PSS-Gloves_USAT.png',
    hasConfigurator: true,
    href: '/m5/EPRO%2029943--Official-Daedo-Gen3-Gloves.html',
    badge: 'New',
  },
  {
    name: 'Gen3 E-Foot Gear',
    price: '$110.84',
    image:
      'https://cdn.magicpatterns.com/uploads/gsMbZUADtxm6tprbLcqPTT/Gen3_E-Foot_Gear.jpg',
    hasConfigurator: true,
    href: GEN3_EFOOT_URL,
    badge: 'New',
  },
  {
    name: 'Gen2 Transmitter Charger',
    price: '$55.00',
    image:
      'https://cdn.magicpatterns.com/uploads/qEV6XsHhowYMSa1F9qrPwc/Gen2_Transmitter_Charger.jpg',
  },
  {
    name: 'Gen2 E-Chest Gear Adult Size',
    price: '$775.00',
    image:
      'https://cdn.magicpatterns.com/uploads/kfguP8tNDqA8zXYkxoyPcg/Gen2_E-Chest_Gear_Adult_Size.jpg',
    hasConfigurator: true,
    href: '/E-Chest-Gear-Adult',
  },
  {
    name: 'Gen2 E-Foot Gear',
    price: '$95.00',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FDaedo%2FGeneration2%2Fepro29037_1_optimizacionweb.jpg',
    hasConfigurator: true,
  },
  {
    name: 'Daedo Truescore E-Foot Gear Magnet Tester',
    price: '$9.99',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2Fdaedo-e-footgear-magnet-tester.jpg',
  },
  {
    name: 'Gen2 Receiver',
    price: '$390.00',
    image:
      'https://cdn.magicpatterns.com/uploads/w3Q65FCerZEu2ek6y4Xdyo/Gen2_Receiver.jpg',
  },
  {
    name: 'Gen2 E-HeadGear',
    price: '$399.00',
    image:
      'https://cdn.magicpatterns.com/uploads/oEDj2ZvCJJBgsVECUR8bR3/Gen2_E-HeadGear.jpg',
    hasConfigurator: true,
  },
]

const WACOKU_PRODUCTS: CategoryProduct[] = [
  {
    name: 'Wacoku Intro Colored Belt Uniform',
    price: '$37.00',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FRedesign%2FWacokuIntro.jpg',
    hasConfigurator: true,
  },
  {
    name: 'Stephen Lambdin Special Edition Wacoku Competition Uniform',
    price: '$80.00',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FCustomUniform%2FStephen-Lambdin-TKD-Uniform.png',
    hasConfigurator: true,
  },
  {
    name: 'Wacoku WTF/WT Lightweight Uniform',
    price: '$75.00',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20AT210B.jpg800x800.jpg',
    hasConfigurator: true,
  },
  {
    name: 'Wacoku WTF/WT Diamond with Ventilation Uniform',
    price: '$99.00',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20AT220B.jpg',
    hasConfigurator: true,
  },
  {
    name: 'Wacoku WTF/WT Reversible Chest Gear',
    price: '$70.00',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20B132W-1.jpg800x800.jpg',
    hasConfigurator: true,
  },
  {
    name: 'Wacoku WTF/WT Shin Guard',
    price: '$33.00',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20B167.jpg800x800.jpg',
    hasConfigurator: true,
  },
  {
    name: 'Wacoku WTF/WT Forearm Guard',
    price: '$32.00',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20B166.jpg800x800.jpg',
    hasConfigurator: true,
  },
  {
    name: 'Wacoku WTF/WT Headgear',
    price: '$49.99',
    image:
      'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=9848&user=1373&w=400&h=400&file=uploaded%2Fimages%2FWacoku%2FWTF%20I201.jpg800x800.jpg',
    hasConfigurator: true,
  },
]

const GEN3_PRODUCTS: CategoryProduct[] = [
  {
    name: 'Gen3-PSS-Gloves USAT',
    price: '$69.00',
    image:
      'https://cdn.magicpatterns.com/uploads/niYhHZHhKrMG2frXtC3Vmj/Gen3_PSS-Gloves_USAT.png',
    hasConfigurator: true,
    href: '/m5/EPRO%2029943--Official-Daedo-Gen3-Gloves.html',
    badge: 'New',
  },
  {
    name: 'Gen3 E-Foot Gear',
    price: '$110.84',
    image:
      'https://cdn.magicpatterns.com/uploads/cViGkDXcDmPVipYt9uyQmt/Gen3_E-Foot_Gear.jpg',
    hasConfigurator: true,
    href: GEN3_EFOOT_URL,
    badge: 'New',
  },
  {
    name: 'Gen3 Transmitter TK-Strike (Head)',
    price: '$556.85',
    image:
      'https://cdn.magicpatterns.com/uploads/32CSZRc127TCj3au4ThHui/GEN3_TRANSMITTER_TK-STRIKE_(HEAD).webp',
    hasConfigurator: true,
    href: '/m5/EPRO%2029902-U-0--gen3-e-head-transmitter-tk-strike-head.html',
  },
  {
    name: 'Gen3 Transmitter TK-Strike (Body)',
    price: '$459.35',
    image:
      'https://cdn.magicpatterns.com/uploads/1ih3djYezzVq8985HX8oSL/GEN3_TRANSMITTER_TK-STRIKE_(BODY).webp',
    hasConfigurator: true,
    href: '/m5/EPRO%2029901-U-0--gen3-transmitter-tk-strike-body.html',
  },
  {
    name: 'TK-Strike Gen3 Receiver',
    price: '$688.34',
    image:
      'https://cdn.magicpatterns.com/uploads/55DtFd96dsvi8vp6TjTcGE/TK-STRIKE_GEN3_RECEIVER.webp',
    hasConfigurator: true,
    href: '/m5/EPRO%2029926-U-0--tk-strike-gen3-receiver.html',
  },
  {
    name: 'Gen3 Electronic Body Protector',
    price: '$847.22',
    image:
      'https://cdn.magicpatterns.com/uploads/nf6K7oc2o7k9Lq2qdDp2cD/Red-GEN3_ELECTRONIC_BODY_PROTECTOR.webp',
    hasConfigurator: true,
    href: '/m5/EPRO%202990--gen3-e-hogus.html',
  },
  {
    name: 'Gen3 E-Head Gear',
    price: '$399.99',
    image:
      'https://cdn.magicpatterns.com/uploads/pZymF2e8PGGmiMTnD1QNCR/Red-and-BlueGEN3_E-HEAD_GEAR.webp',
    hasConfigurator: true,
    href: '/m5/EPRO%2029913--gen3-e-head-gear.html',
  },
  {
    name: 'Gen 3 Software Download',
    price: '$99.99',
    image:
      'https://cdn.magicpatterns.com/uploads/uzhJjiwifSbakuQBq1HFz4/Gen3_Software_download.png',
    href: '/m5/EPRO%2029907-U-0--gen3-software-download.html',
  },
]

export const CATEGORIES = {
  all: {
    title: 'Shop All Products',
    description:
      'Browse our complete catalog of Daedo and Wacoku Taekwondo equipment, including electronic scoring systems, protective gear, uniforms, and training accessories. Every product on TKDScore.com is sourced through official channels and backed by our U.S.-based support team.',
    products: [
      ...GEN3_PRODUCTS,
      ...DAEDO_PSS_PRODUCTS,
      ...DAEDO_PRODUCTS,
      ...WACOKU_PRODUCTS,
    ],
  },
  'gen-3': {
    title: 'Gen 3',
    description:
      'The newest generation of Daedo electronic scoring gear. Gen 3 introduces redesigned transmitters, improved hit-detection accuracy, and tournament-ready performance trusted at the highest levels of competition.',
    products: GEN3_PRODUCTS,
  },
  'daedo-pss-system': {
    title: 'Daedo PSS Systems',
    description:
      'Complete electronic scoring systems from Daedo, including receivers, transmitters, judge boxes, and W.T.-approved software. Build a full Gen 2 or Gen 3 setup for your school, tournament, or training center.',
    products: DAEDO_PSS_PRODUCTS,
  },
  'daedo-products': {
    title: 'Daedo Products',
    description:
      'Official Daedo gear including gloves, e-foot gear, headgear, body protectors, transmitters, and accessories. Compatible with both Gen 2 and Gen 3 scoring systems.',
    products: DAEDO_PRODUCTS,
  },
  'wacoku-products': {
    title: 'Wacoku Products',
    description:
      'WT-approved Wacoku protective equipment, competition uniforms, and training accessories. Lightweight, durable, and trusted by athletes from beginner to elite levels.',
    products: WACOKU_PRODUCTS,
  },
} as const

export type CategorySlug = keyof typeof CATEGORIES
